module.exports = __webpack_public_path__ + "img/HT01034-02.7f7b84c3.jpg";